export default [
  {
    id: Math.random() * Date.now(),
    name: "meetups app",
    url: 'https://svelte-meetups.netlify.app/'
  },
  {
    id: Math.random() * Date.now(),
    name: "budget calculator",
    url: 'https://sveltejs-budget-calculator.netlify.app/'
  },
  {
    id: Math.random() * Date.now(),
    name: "Todo app",
    url: 'https://sveltejs-todo-app.netlify.app/'
  },
  {
    id: Math.random() * Date.now(),
    name: "testing-library meetup",
    url: 'https://github.com/silvestrevivo/svelte-testing-library-meetup'
  },
  {
    id: Math.random() * Date.now(),
    name: "npm svelte-marquee",
    url: 'https://www.npmjs.com/package/svelte-marquee'
  },
  {
    id: Math.random() * Date.now(),
    name: "svelte-strapi-ecommerce",
    url: 'https://svelte-ecommerce.netlify.app/'
  },
  {
    id: Math.random() * Date.now(),
    name: "benditaburger e-commerce",
    url: 'https://benditaburger.es/'
  }
];
